import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { UAT_DATA } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';
import { UatPaymentDataType, UatPaymentMethodResponseType } from 'src/app/types/response/document-state.response.type';

@Component({
  standalone: false,
  selector: 'app-uat-payment-method',
  templateUrl: './uat-payment-method.component.html',
  styleUrl: './uat-payment-method.component.scss'
})
export class UatPaymentMethodComponent implements OnChanges {
  destroy$: Subject<void> = new Subject<void>();
  @Input() uatPaymentMethod: UatPaymentMethodResponseType[] = [];
  @Input() uatData: UatPaymentDataType[] = [];
  paymentMethodForm!: FormGroup;
  current: number = 1;
  isConfirmBack: boolean = false
  @Output() openModalConfirmBack = new EventEmitter<boolean>();

  constructor(
    private baseService: BaseService,
    private fb: FormBuilder,
    private router: Router,
    private message: NzMessageService,
  ) {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['uatPaymentMethod'] && this.uatPaymentMethod?.length > 0) {
      if (!this.paymentMethodForm) {
        this.paymentMethodForm = this.fb.group({});
      }
      this.uatPaymentMethod.forEach(item => {
        if (!this.paymentMethodForm.contains(`curl_${item.id}`)) {
          this.paymentMethodForm.addControl(`curl_${item.id}`, this.fb.control(null, Validators.required));
          this.paymentMethodForm.addControl(`result_${item.id}`, this.fb.control(null, Validators.required));
        }
      });
    }

    if ((changes['uatData'] || changes['uatPaymentMethod']) && this.uatData?.length > 0 && this.paymentMethodForm) {
      this.uatPaymentMethod.forEach(method => {
        const data = this.uatData.find(d => d.test_case_id === method.id);
        if (data) {
          this.paymentMethodForm.patchValue({
            [`curl_${method.id}`]: data.curl,
            [`result_${method.id}`]: data.result
          });
          method.notes = data.notes;
        }
      });
    }
  }

  initForm() {
    this.paymentMethodForm = this.fb.group({});
  }

  next(): void {
    this.submitUat()
    this.router.navigate(['/document/uat-data-input-payment'], { queryParams: { step: this.current + 1 } });
  }
  previus(): void {
    this.isConfirmBack = true
  }

  closeConfirmBack() {
    this.isConfirmBack = false
  }



  submitUat() {
    const input = this.uatPaymentMethod.map(item => ({
      test_case_id: item.id,
      curl: this.paymentMethodForm.get(`curl_${item.id}`)?.value,
      result: this.paymentMethodForm.get(`result_${item.id}`)?.value,
      service_types_id: 2
    }));
    this.baseService.postData(UAT_DATA, { input })
    .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        localStorage.setItem('uat-payment-method', 'complete')
      }, (err) => {
        console.error(err.error.data.errors)
      });
  }

  formatJson(val: any): string {
    if (!val) return '-';
    try {
      const parsed = typeof val === 'string' ? JSON.parse(val) : val;
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return String(val);
    }
  }
}
